import { JogId } from ".";
import { Viewport } from "../map";

export const getDefaultViewport = (jogId: JogId | string = ""): Viewport => {
  const createViewObj = (latitude: number, longitude: number, zoom: number) => {
    return { latitude, longitude, zoom }
  }
  
  // For actual JOGs
  const Vancouver = createViewObj(45.69839378104345, -122.66282168292611, 10.40);
  const JBLM = createViewObj(46.99493139215082, -122.68381641682382, 10.22);
  const Sammamish = createViewObj(47.59588841857993, -122.08047019989192, 10.44);
  const Kent = createViewObj(47.394519133295375, -122.14410124420516, 10.66);
  const OlympicPeninsulaCenter = createViewObj(47.648751283542055, -123.50677640548192, 8.67);
  const LowerColumbiaRiver = createViewObj(46.244550851642316, -123.49303135573481, 9.30);
  const EdisonWa = createViewObj(48.56852143682946, -122.43116200833029, 9.12);
  const Seattle5thAndMadison = createViewObj(47.6062, -122.3321, 10);
  const NorthOfMonroe = createViewObj(47.97032804081408, -121.95253938794517, 9.74);
  const TacomaSummitArea = createViewObj(47.17919387103203, -122.39243960781482, 10.78);
  const Wenatchee = createViewObj(47.42341645562598, -120.31044328252437, 7.00);

   // For "Groups" that are not actual JOGs
  const Ephrata = createViewObj(47.31726834490044, -119.55280036861137, 6.5); // For Eastern WA Group
  const WenatcheeWide = createViewObj(47.42341645562598, -120.31044328252437, 6); // For WSP "group"

  // For possible future JOGs
  const LewisCountyEastOfChehalis = createViewObj(46.66453203112545, -122.76350372954892, 9.00);
  const Spokane = createViewObj(47.6579413324723, -117.42349656531653, 7.0);
  const Pasco = createViewObj(46.22279349384027, -119.06992285209593, 7.0);

  
  switch (jogId as JogId) {
    case JogId.EasternWa:
      return Ephrata;
    case JogId.KingCountyNortheast:
      return Sammamish;
    case JogId.KingCountySouth:
      return Kent;
    case JogId.Tacoma:
      return TacomaSummitArea;
    case JogId.JBLM:
      return JBLM;
    case JogId.SnohomishCounty:
      return NorthOfMonroe;
    case JogId.KitsapPeninsula:
      return OlympicPeninsulaCenter;
    case JogId.ClarkCounty:
      return Vancouver;
    case JogId.LewisCounty:
      return LewisCountyEastOfChehalis;
    case JogId.LowerColumbiaRiver:
      return LowerColumbiaRiver;
    case JogId.NorthwestWa:
      return EdisonWa;
    // case JogId.Spokane:
    //   return Spokane;
    // case JogId.TriCities:
    //   return Pasco;
    case JogId.Wsp:
      return WenatcheeWide;
    case JogId.NorthCentralWa:
      return Wenatchee;
    case JogId.NortheastWa:
      return Spokane;
    case JogId.SouthCentralWa:
      return Pasco;
    case JogId.SoutheastWa:
      return Pasco;
    case JogId.SeattleArea:
    default:
      return Seattle5thAndMadison;
  }
};